<div>
    <ws-ace-loader [show]="loading" [hasOverlay]="false"></ws-ace-loader>
    @if (!loading) {
        <form [formGroup]="attachmentForm">
            <div class="mb-4">
                <label for="type">Type</label>
                <ws-select name="type"
                           id="type"
                           formControlName="type"
                           labelProperty="displayName"
                           [returnEntireOption]="true"
                           [options]="attachmentTypes | sortBy:'asc':'displayName'"
                           [disabled]="disableAttachmentType">
                </ws-select>
                @if ((type.dirty && (type.errors && type.errors.required))) {
                    <span class="text-danger">Type is required.</span>
                }
            </div>
            <div class="mb-4">
                <label for="taxYear">Year</label>
                <ws-select id="taxYear"
                           name="taxYear"
                           labelProperty="name"
                           formControlName="year"
                           [options]="years">
                </ws-select>
                @if ((year.errors && year.errors.required)) {
                    <span class="text-danger">Year is required for the selected type.</span>
                }
            </div>
            <div class="mb-4">
                <label for="attachmentDescription">Description</label>
                <textarea id="attachmentDescription"
                          rows="3"
                          class="form-control"
                          formControlName="description"
                          maxlength="255">
        </textarea>
            </div>
            @if (!attachment?.attachmentID) {
                <div class="mb-4">
                    <label>File Upload</label>
                    <ws-file-picker formControlName="files" (picked)="attachmentFilePicked($event)"></ws-file-picker>
                </div>
            }
            @if (attachment?.attachmentID) {
                <div class="mb-4">
                    <button class="ace-btn btn-sm btn-primary btn-danger"
                            (click)="deleteAttachment()"
                            [disabled]="isSaving">
                        @if (!isDeleting) {
                            <span>Delete Attachment</span>
                        }
                        @if (isDeleting) {
                            <span>Deleting...</span>
                        }
                    </button>
                </div>
            }
            @if (attachment?.type?.isRyanInternal) {
                <p title="Attachment visibility is determined by type">
                    Only visible to Ryan personnel
                </p>
            }
            <div class="ws-button-row ace-button-container">
                <button type="submit"
                        class="ace-btn btn-primary"
                        (click)="save()"
                        [disabled]="attachmentForm.invalid || isSaving || isDeleting || (!attachment?.attachmentID && !file.value)">
                    {{ submitButtonLabel }}
                </button>
                <button class="ace-btn btn-secondary"
                        (click)="cancel()"
                        [disabled]="isSaving || isDeleting">Cancel
                </button>
            </div>
        </form>
    }
</div>
